<template>
  <div class="text-center">
    <div class="row no-gutters justify-content-between mb-1">
      <div class="col-sm-auto flex-grow-0">
        <h3 class="mb-0 text-left">PSC Inspection List</h3>
      </div>
      <div class="col-sm-auto">
        <div class="row">
          <div class="col-sm-auto float-right pr-0" v-if="isAllowed('psc.index.create')">
            <button class="e-btn e-btn-green force-white-all" data-toggle="modal" data-target="#NewPscInspection">
              <font-awesome-icon icon="plus-square" style="width: 25px"/>
              <small class="font-weight-bold px-2">
                NEW PSC INSPECTION
              </small>
            </button>
          </div>
          <div class="col-sm-auto float-right pr-0" v-if="isAllowed('psc.index.import')">
            <button class="e-btn e-btn-blue force-white-all pr-3" data-toggle="modal" data-target="#ImportPscReportModal">
              <font-awesome-icon icon="plus-square" style="width: 25px"/>
              <small class="font-weight-bold">
                IMPORT
              </small>
            </button>
          </div>
          <div class="col-sm-auto float-right" v-if="isAllowed('psc.index.download-template')">
            <template v-if="!toExport">
              <div class="input-group">
                <button class="e-btn e-btn-blue-gray force-white-all" @click="toExport=!toExport">
                  <font-awesome-icon icon="file-excel" style="width: 20px"/>
                  <small class="font-weight-bold">
                    PSC INSPECTION TEMPLATE
                  </small>
                </button>
              </div>
            </template>
            <template v-else>
              <div class="input-group-sm">
                <input type="number" min="1" max="30" placeholder="How many # of Deficiency?" class="form-control form-control-sm" id="exportDeficiencyCount"
                       v-model="exportDeficiencyCount" required autofocus>
                <select class="text-uppercase form-control form-control-sm" id="exportVesselId" v-model="exportVesselId" required>
                  <option :value="null" disabled>— Select Vessel —</option>
                  <option v-for="vessel in vesselKeys" :key="vessel.id" :value="vessel.id">
                    {{ vessel?.name }}
                  </option>
                </select>
                <div class="input-group-append">
                  <button class="form-control form-control-sm btn btn-sm btn-outline-secondary e-btn-red force-white-all" type="button"
                          @click="exportBlankTemplate(true)">
                    <font-awesome-icon icon="ban"/>
                  </button>
                  <button class="form-control form-control-sm btn btn-sm btn-outline-secondary e-btn-green force-white-all" type="button"
                          @click="exportBlankTemplate">
                    <font-awesome-icon icon="download"/>
                  </button>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>

    <div class="row no-gutters align-items-center justify-content-between">
      <div class="col-sm-auto pb-2 mr-2">
        <nav aria-label="...">
          <ul class="pagination text-smallest mb-0 pb-0">
            <li class="page-item" :class="{ 'disabled': pagination.currentPage === 1}">
              <button class="page-link" @click="setPage(1)">First</button>
            </li>

            <li v-for="page in paginationPages" :key="page" class="page-item"
                :class="{ 'disabled': page === '...', 'active': page === pagination.currentPage }">
              <button class="page-link" @click="setPage(page)">{{ page }}</button>
            </li>

            <li class="page-item" :class="{ 'disabled': pagination.currentPage === pagination.lastPage}">
              <button class="page-link" @click="setPage(pagination.lastPage)">Last</button>
            </li>
          </ul>
        </nav>
      </div>
      <div class="col-sm-auto pb-2">
        <div class="input-group input-group-sm">
          <div class="input-group-prepend">
            <label class="input-group-text input-group-sm bg-white small border-0" for="rowCount"># of Row(s):</label>
          </div>
          <select class="form-control form-control-sm rounded-left" v-model="filters.count" @change="handleFilterChange('count', filters.count)" id="rowCount">
            <option value="30">30</option>
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="10000">All</option>
          </select>
        </div>
      </div>
    </div>
    <div class="row no-gutters align-items-center justify-content-end">
      <div class="row mb-3 no-gutters justify-content-between align-items-center">
        <div class="col-lg-12 ">
          <div class="row no-gutters align-items-center">
<!--            <div class="col-md-auto">-->
<!--              <label class="col-form-label pr-2 font-weight-bold">Filter By: </label>-->
<!--            </div>-->
<!--            <div class="col-md-auto px-1">-->
<!--              <select name="" id="" class="form-inline form-control form-control-sm form-control-xs" v-model="filters.fleet_id">-->
<!--                <option :value="null">&#45;&#45; ALL FLEET &#45;&#45;</option>-->
<!--                <option :value="fleet.id" v-for="fleet in fleetKeys">{{fleet.name ? fleet.name.toUpperCase() : ''}}</option>-->
<!--              </select>-->
<!--            </div>-->
<!--            <div class="col-md-auto px-1">-->
<!--              <select class="form-control form-control-sm text-uppercase" id="fleetList" v-model="filters.fleet_id" @change="handleFilterChange('fleet_id', filters.fleet_id)">-->
<!--                &lt;!&ndash;                <option :value="null">—— SELECT PORT ——</option>&ndash;&gt;-->
<!--                <option :value="null">&#45;&#45; ALL FLEET &#45;&#45;</option>-->
<!--                <template v-for="fleet in fleetKeys">-->
<!--                  <option :value="fleet.id" v-if="fleet?.name !== 'N/A' && fleet.code !== 'N/A'">-->
<!--                    {{fleet.name ? fleet.name.toUpperCase() : ''}}-->
<!--                  </option>-->
<!--                </template>-->
<!--              </select>-->
<!--            </div>-->
<!--            <div class="col-md-auto px-1">-->
<!--              <date-picker id = "date-picker" :lang = 'en' type="date" valueType="format" placeholder="Select Date Range" range v-model="date_range" @change="handleDateRange(date_range)"></date-picker>-->
<!--            </div>-->
<!--            <div class="col-md-auto px-1">-->
<!--              <select class="form-control form-control-sm text-uppercase" id="CountryList"  v-model="filters.country_id" @change="handleFilterChange('country_id', filters.country_id)">-->
<!--                <option :value="null">—— SELECT COUNTRY ——</option>-->
<!--                <option :value="null">—— ALL COUNTRIES ——</option>-->
<!--                <option v-for="country in countryKeys" :key="country.id" :value="country.id">-->
<!--                  {{ country?.name }}-->
<!--                </option>-->
<!--              </select>-->
<!--            </div>-->
<!--            <div class="col-md-auto px-1">-->
<!--              <select class="form-control form-control-sm text-uppercase" id="PortList" v-model="filters.port_id" @change="handleFilterChange('port_id', filters.port_id)" :disabled="!ports.length">-->
<!--                <option :value="null">—— SELECT PORT ——</option>-->
<!--                <option :value="null">—— ALL PORTS ——</option>-->
<!--                <option v-for="port in ports" :key="port.id" :value="port.id">-->
<!--                  {{ port?.name }} {{ port.locode_wrap }}-->
<!--                </option>-->
<!--              </select>-->
<!--            </div>-->
            <div class="col-md-auto px-1">
              <div class="float-right text-right ml-2 dropdown dropright" v-if="true">
                <button id="committeeReport" aria-expanded="false" aria-haspopup="true" class="mr-2 e-btn e-btn-primary force-white-all"
                        data-toggle="dropdown"
                        :disabled="reports.length === 0 || loading === true"
                        :class="reports.length === 0 || loading === true ? 'e-btn-blue-gray-disabled' : ''"
                >
                  <font-awesome-icon class="mr-1" icon="download"/>
                  Download
                </button>
                <div aria-labelledby="committeeReport" class="dropdown-menu">
                  <button class="dropdown-item text-secondary font-weight-bolder" @click="downloadReport('excel')" type="button">
                    <font-awesome-icon icon="file-excel"/>
                    Excel
                  </button>
                  <button class="dropdown-item text-secondary font-weight-bolder" @click="downloadReport('pdf')" type="button">
                    <font-awesome-icon icon="file-pdf"/>
                    PDF
                  </button>
                </div>
              </div>
            </div>
            <div class="col-md-auto px-1" v-if="isElite()">
              <div class="float-right text-right ml-2">
                <button id="committeeReport" class="mr-2 e-btn e-btn-primary force-white-all"
                        :disabled="reports.length === 0 || loading === true"
                        :class="reports.length === 0 || loading === true ? 'e-btn-blue-gray-disabled' : ''"
                        @click="downloadReportStatusHistory"
                >
                  <font-awesome-icon class="mr-1" icon="download"/>
                  Download Report Status History
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row no-gutters" style="height: 75vh; overflow-y: auto">
      <div class="col-12">
        <table class="small e-tbl custom-table-border">
          <thead class="bg-white" style="position: sticky; top: 0; z-index: 2">
          <tr>
            <th class="align-middle" style="width: 1em" scope="col">#</th>
            <th class="align-middle" scope="col" style="width: 150px !important;" @click="sortByCategory('vessel')">
              <div class="white-space-no-wrap">
                VESSEL
                <span style="cursor: pointer" class="h6 ml-2">
                  <font-awesome-icon icon="arrow-up" v-if="filters.order_position === 'asc' && filters.category === 'vessel'" class="sort-arrow-up"/>
                  <font-awesome-icon icon="arrow-down" v-else-if="filters.order_position === 'desc' && filters.category === 'vessel'" class="sort-arrow-down"/>
                  <font-awesome-icon icon="sort" v-else/>
                </span>
              </div>
            </th>
            <th class="align-middle" scope="col" @click="sortByCategory('manager')">
              <div class="white-space-no-wrap">
                MANAGER
                <span style="cursor: pointer" class="h6 ml-2">
                  <font-awesome-icon icon="arrow-up" v-if="filters.order_position === 'asc' && filters.category === 'manager'" class="sort-arrow-up"/>
                  <font-awesome-icon icon="arrow-down" v-else-if="filters.order_position === 'desc' && filters.category === 'manager'" class="sort-arrow-down"/>
                  <font-awesome-icon icon="sort" v-else/>
                </span>
              </div>
            </th>
            <th class="align-middle" style="min-width: 25em" scope="col" @click="sortByCategory('title')">
              <div class="white-space-no-wrap">
                REPORT TITLE
                <span style="cursor: pointer" class="h6 ml-2">
                  <font-awesome-icon icon="arrow-up" v-if="filters.order_position === 'asc' && filters.category === 'title'" class="sort-arrow-up"/>
                  <font-awesome-icon icon="arrow-down" v-else-if="filters.order_position === 'desc' && filters.category === 'title'" class="sort-arrow-down"/>
                  <font-awesome-icon icon="sort" v-else/>
                </span>
              </div>
            </th>
            <th class="align-middle" style="width: 5em" scope="col" @click="sortByCategory('report_status')">
              <div class="white-space-no-wrap">
                STATUS
                <span style="cursor: pointer" class="h6 ml-2">
                  <font-awesome-icon icon="arrow-up" v-if="filters.order_position === 'asc' && filters.category === 'report_status'" class="sort-arrow-up"/>
                  <font-awesome-icon icon="arrow-down" v-else-if="filters.order_position === 'desc' && filters.category === 'report_status'" class="sort-arrow-down"/>
                  <font-awesome-icon icon="sort" v-else/>
                </span>
              </div>
            </th>
            <th class="align-middle" style="width: 10em" scope="col" @click="sortByCategory('fleet')">
              <div class="white-space-no-wrap">
                FLEET
                <span style="cursor: pointer" class="h6 ml-2">
                  <font-awesome-icon icon="arrow-up" v-if="filters.order_position === 'asc' && filters.category === 'fleet'" class="sort-arrow-up"/>
                  <font-awesome-icon icon="arrow-down" v-else-if="filters.order_position === 'desc' && filters.category === 'fleet'" class="sort-arrow-down"/>
                  <font-awesome-icon icon="sort" v-else/>
                </span>
              </div>
            </th>
            <th class="align-middle" style="width: 10em" scope="col" @click="sortByCategory('port')">
              <div class="white-space-no-wrap">
                PORT
                <span style="cursor: pointer" class="h6 ml-2">
                  <font-awesome-icon icon="arrow-up" v-if="filters.order_position === 'asc' && filters.category === 'port'" class="sort-arrow-up"/>
                  <font-awesome-icon icon="arrow-down" v-else-if="filters.order_position === 'desc' && filters.category === 'port'" class="sort-arrow-down"/>
                  <font-awesome-icon icon="sort" v-else/>
                </span>
              </div>
            </th>
            <th class="align-middle" style="width: 7em" scope="col" @click="sortByCategory('country')">
              <div class="white-space-no-wrap">
                COUNTRY
                <span style="cursor: pointer" class="h6 ml-2">
                  <font-awesome-icon icon="arrow-up" v-if="filters.order_position === 'asc' && filters.category === 'country'" class="sort-arrow-up"/>
                  <font-awesome-icon icon="arrow-down" v-else-if="filters.order_position === 'desc' && filters.category === 'country'" class="sort-arrow-down"/>
                  <font-awesome-icon icon="sort" v-else/>
                </span>
              </div>
            </th>
            <th class="align-middle" style="min-width: 9em" scope="col" @click="sortByCategory('inspection_date_original_format')">
              <div class="white-space-no-wrap">
                INSPECTION DATE
                <span style="cursor: pointer" class="h6 ml-2">
                      <font-awesome-icon icon="arrow-up" v-if="filters.order_position === 'asc' && filters.category === 'inspection_date_original_format'" class="sort-arrow-up"/>
                      <font-awesome-icon icon="arrow-down" v-else-if="filters.order_position === 'desc' && filters.category === 'inspection_date_original_format'" class="sort-arrow-down"/>
                      <font-awesome-icon icon="sort" v-else/>
                    </span>
              </div>
            </th>
            <th class="align-middle" style="width: 1em; font-size: 11px;" scope="col">PSC REPORT</th>
            <th class="align-middle" style="min-width: 9em" scope="col" @click="sortByCategory('deficiencyCount')">
              <div class="white-space-no-wrap">
                NO. DEF
                <span style="cursor: pointer" class="h6 ml-2">
                  <font-awesome-icon icon="arrow-up" v-if="filters.order_position === 'asc' && filters.category === 'deficiencyCount'" class="sort-arrow-up"/>
                  <font-awesome-icon icon="arrow-down" v-else-if="filters.order_position === 'desc' && filters.category === 'deficiencyCount'" class="sort-arrow-down"/>
                  <font-awesome-icon icon="sort" v-else/>
                </span>
              </div>
            </th>
            <th class="align-middle" style="min-width: 9em" scope="col">DEF STATUS</th>
            <th class="align-middle" style="min-width: 9em" scope="col" @click="sortByCategory('detention')">
              <div class="white-space-no-wrap">
                DETENTION
                <span style="cursor: pointer" class="h6 ml-2">
                  <font-awesome-icon icon="arrow-up" v-if="filters.order_position === 'asc' && filters.category === 'detention'" class="sort-arrow-up"/>
                  <font-awesome-icon icon="arrow-down" v-else-if="filters.order_position === 'desc' && filters.category === 'detention'" class="sort-arrow-down"/>
                  <font-awesome-icon icon="sort" v-else/>
                </span>
              </div>
            </th>
            <th class="align-middle" style="width: 12em" scope="col" @click="sortByCategory('responsible_person')">
              <div class="white-space-no-wrap">
                RESPONSIBLE
                <span style="cursor: pointer" class="h6 ml-2">
                  <font-awesome-icon icon="arrow-up" v-if="filters.order_position === 'asc' && filters.category === 'responsible_person'" class="sort-arrow-up"/>
                  <font-awesome-icon icon="arrow-down" v-else-if="filters.order_position === 'desc' && filters.category === 'responsible_person'" class="sort-arrow-down"/>
                  <font-awesome-icon icon="sort" v-else/>
                </span>
              </div>
            </th>
            <th class="align-middle" style="width: 12em" scope="col" @click="sortByCategory('person_in_charge')">
              <div class="white-space-no-wrap">
                PERSON IN CHARGE
                <span style="cursor: pointer" class="h6 ml-2">
                  <font-awesome-icon icon="arrow-up" v-if="filters.order_position === 'asc' && filters.category === 'person_in_charge'" class="sort-arrow-up"/>
                  <font-awesome-icon icon="arrow-down" v-else-if="filters.order_position === 'desc' && filters.category === 'person_in_charge'" class="sort-arrow-down"/>
                  <font-awesome-icon icon="sort" v-else/>
                </span>
              </div>
            </th>
            <th class="align-middle" style="width: 12em" scope="col" @click="sortByCategory('created_by')">
              <div class="white-space-no-wrap">
                CREATED BY
                <span style="cursor: pointer" class="h6 ml-2">
                  <font-awesome-icon icon="arrow-up" v-if="filters.order_position === 'asc' && filters.category === 'created_by'" class="sort-arrow-up"/>
                  <font-awesome-icon icon="arrow-down" v-else-if="filters.order_position === 'desc' && filters.category === 'created_by'" class="sort-arrow-down"/>
                  <font-awesome-icon icon="sort" v-else/>
                </span>
              </div>
            </th>
            <th class="align-middle" style="width: 70px" scope="col">ACTION</th>
          </tr>
          <tr>
            <th class="align-middle" style="width: 2em" scope="col">&nbsp;</th>
            <th class="align-middle" style="background-color: rgb(225, 225, 225); cursor: pointer;" scope="col">
              <table-column-search
                v-model="filters.vessel"
                @callRequestFunction="setVesselsToTable"
                :x_button_z_index="9"
                style="width: 150px !important;"
              />
            </th>
            <th class="align-middle" style="background-color: rgb(225, 225, 225); cursor: pointer;" scope="col">
              <table-column-search
                v-model="filters.manager"
                @callRequestFunction="setVesselsToTable"
                :x_button_z_index="9"
                style="width: 150px !important;"
              />
            </th>
            <th class="align-middle" style="background-color: rgb(225, 225, 225); cursor: pointer;" scope="col">
              <table-column-search
                v-model="filters.title"
                @callRequestFunction="setVesselsToTable"
                :x_button_z_index="9"
              />
            </th>
            <th class="align-middle" style="background-color: rgb(225, 225, 225); cursor: pointer;" scope="col">
<!--              <table-column-search-->
<!--                v-model="filters.report_status"-->
<!--                @callRequestFunction="setVesselsToTable"-->
<!--                :x_button_z_index="9"-->
<!--              />-->
              <div class="d-flex align-items-center w-auto">
                <div class="input-group position-relative">
                  <select v-model="filters.report_status" class="form-control form-control-sm text-center" style="width: 160px;" @change="setVesselsToTable">
                    <option :value="null" :selected="true">-- ALL --</option>
                    <option v-for="(reportStatusKey, index) in reportStatusKeyModify" :key="index" :value="reportStatusKey.name">{{reportStatusKey.name}}</option>
                  </select>
                </div>
                <font-awesome-icon
                  class="ml-2"
                  icon="filter"
                  style="cursor: pointer;"
                  @click.prevent="setVesselsToTable"
                />
              </div>
            </th>
            <th class="align-middle" style="background-color: rgb(225, 225, 225); cursor: pointer;" scope="col">
              <div class="d-flex align-items-center w-auto">
                <div class="input-group position-relative">
                  <select v-model="filters.fleet_id" class="form-control form-control-sm text-center" style="width: 130px;" @change="setVesselsToTable">
                    <option :value="null" :selected="true">-- ALL --</option>
                    <option v-for="(fleetKey, index) in fleetKeys.filter(fleet => fleet.name?.toUpperCase() !== 'N/A')" :key="index" :value="fleetKey.id">{{fleetKey.name}}</option>
                  </select>
                </div>
                <font-awesome-icon
                  class="ml-2"
                  icon="filter"
                  style="cursor: pointer;"
                  @click.prevent="setVesselsToTable"
                />
              </div>
            </th>
            <th class="align-middle" style="background-color: rgb(225, 225, 225); cursor: pointer;" scope="col">
              <table-column-search
                v-model="filters.port"
                @callRequestFunction="setVesselsToTable"
                :x_button_z_index="9"
                style="width: 150px !important;"
              />
            </th>
            <th class="align-middle" style="background-color: rgb(225, 225, 225); cursor: pointer;" scope="col">
              <table-column-search
                v-model="filters.country"
                @callRequestFunction="setVesselsToTable"
                :x_button_z_index="9"
                style="width: 150px !important;"
              />
            </th>
            <th class="align-middle" style="background-color: rgb(225, 225, 225); cursor: pointer;" scope="col">
<!--              <table-column-search-->
<!--                v-model="filters.inspection_date"-->
<!--                @callRequestFunction="setVesselsToTable"-->
<!--                :x_button_z_index="9"-->
<!--              />-->
              <div class="d-flex align-items-center w-auto">
                <div class="input-group position-relative">
                  <date-picker id = "date-picker" :lang="en" type="date" :style="{ width: '200px' }" valueType="format" range v-model="dateRangeInspection" @change="setVesselsToTable" lang="en"></date-picker>
                </div>
                <font-awesome-icon
                  class="ml-2"
                  icon="filter"
                  style="cursor: pointer;"
                  @click.prevent="setVesselsToTable"
                />
              </div>
            </th>
            <th class="align-middle" style="background-color: rgb(225, 225, 225); cursor: pointer;" scope="col"></th>
            <th class="align-middle" style="background-color: rgb(225, 225, 225); cursor: pointer;" scope="col">
              <table-column-search
                v-model="filters.deficiencyCount"
                @callRequestFunction="setVesselsToTable"
                :x_button_z_index="9"
                style="width: 100px !important;"
              />
            </th>
            <th class="align-middle" style="background-color: rgb(225, 225, 225); cursor: pointer;" scope="col"></th>
            <th class="align-middle" style="background-color: rgb(225, 225, 225); cursor: pointer;" scope="col">
              <div class="d-flex align-items-center w-auto">
                <div class="input-group position-relative">
                  <select v-model="filters.detention" class="form-control form-control-sm text-center" style="width: 100px;" @change="setVesselsToTable">
                    <option :value="null" :selected="true">-- ALL --</option>
                    <option value="1" :selected="true">YES</option>
                    <option value="0" :selected="true">NO</option>
                  </select>
                </div>
                <font-awesome-icon
                  class="ml-2"
                  icon="filter"
                  style="cursor: pointer;"
                  @click.prevent="setVesselsToTable"
                />
              </div>
            </th>
            <th class="align-middle" style="background-color: rgb(225, 225, 225); cursor: pointer;" scope="col">
              <table-column-search
                v-model="filters.responsible_person"
                @callRequestFunction="setVesselsToTable"
                :x_button_z_index="9"
                style="width: 150px !important;"
              />
            </th>
            <th class="align-middle" style="background-color: rgb(225, 225, 225); cursor: pointer;" scope="col">
              <table-column-search
                v-model="filters.person_in_charge"
                @callRequestFunction="setVesselsToTable"
                :x_button_z_index="9"
                style="width: 150px !important;"
              />
            </th>
            <th class="align-middle" style="background-color: rgb(225, 225, 225); cursor: pointer;" scope="col">
              <table-column-search
                v-model="filters.created_by"
                @callRequestFunction="setVesselsToTable"
                :x_button_z_index="9"
                style="width: 150px !important;"
              />
            </th>
            <th class="align-middle" style="background-color: rgb(225, 225, 225); cursor: pointer;" scope="col"></th>
          </tr>
          </thead>
          <tbody>
          <tr v-if="loading">
            <td colspan="100%">
              <loading></loading>
            </td>
          </tr>
          <tr v-else-if="!finalizedReports.length && !loading">
            <td colspan="100%" class="text-center py-3">
              No records found.
            </td>
          </tr>
          <template v-else>
            <template v-for="(report, index) in finalizedReports">
              <tr class="text-uppercase" :key="report.id" :class="[new Date(report.inspection_date) <= new Date('2000-01-01') ? 'test-data-row' : '' ]">
                <td>{{ index + pagination.from }}</td>
                <td>{{ report.vessel }}</td>
                <td>{{ report.manager }}</td>
                <td>{{ report.title }}</td>
                <td class="align-middle text-white" :class="['bg-'+report.report_status_color]">
                  {{ report.report_status }}
                </td>
                <td>{{ report.fleet }}</td>
                <td>{{ report.port }}</td>
                <td>{{ report.country }}</td>
                <td>{{ report.inspection_date }}</td>
                <td>
                  <template v-if="getLatestAttachment(report.pscAttachments)">
                    <font-awesome-icon icon="file-pdf" v-if="getLatestAttachment(report.pscAttachments).has_file"
                                       @click="viewDownloadFile(getLatestAttachment(report.pscAttachments),1,'view',report.id)" size="3x"
                                       class="force-danger-all" style="cursor: pointer">
                    </font-awesome-icon>
                    <font-awesome-icon icon="file-pdf" v-else size="3x"></font-awesome-icon>
                  </template>
                </td>
                <td class="align-middle text-center"><p class="py-0 my-0" :class="{'h5 text-danger':report.deficiencyCount > 0}">{{ report.deficiencyCount }}</p></td>
                <td class="p-2" style="width: 6rem">
                  <DeficiencyStatusIndicator :data="report.deficiencyCounts"></DeficiencyStatusIndicator>
                </td>
                <td><p class="py-0 my-0" :class="{'h5 text-danger':report.detention}">{{ report.detention ? 'YES' : 'NO' }}</p></td>
                <td>{{ report.responsible_person }}</td>
                <td>{{ report.person_in_charge }}</td>
                <td>{{ report.created_by?.name }}</td>
                <td class="align-middle text-center">
                  <div class="dropdown dropright my-1">
                    <button id="actionDropdown" aria-expanded="false" aria-haspopup="true"
                            class="btn btn-sm btn-secondary force-white-all" data-toggle="dropdown">
                      <font-awesome-icon icon="cogs"/>
                    </button>
                    <div aria-labelledby="actionDropdown" class="dropdown-menu py-0">
                      <button class="dropdown-item text-secondary font-weight-bolder"
                              @click="showPscInspection(report.id)"
                              v-if="isAllowed('psc.index.view') || isAllowed('psc.main.view')">
                        <font-awesome-icon icon="eye"/>
                        View
                      </button>
                      <button class="dropdown-item text-secondary font-weight-bolder"
                              @click="showPscInspectionNewTab(report.id)"
                              v-if="isAllowed('psc.index.view') || isAllowed('psc.main.view')">
                        <font-awesome-icon icon="share"/>
                        View on New Tab
                      </button>
                      <template v-if="user.is_vessel === true">
                        <button class="dropdown-item text-secondary font-weight-bolder text-danger"
                                @click="verifyDelete(report)"
                                v-if="user.vessel_id === report.vessel_id">
                          <font-awesome-icon icon="trash" class="force-danger-all"/>
                          Delete
                        </button>
                      </template>
                      <template v-else>
                        <button class="dropdown-item text-secondary font-weight-bolder text-danger"
                                @click="verifyDelete(report)"
                                v-if="isAllowed('psc.index.delete') || user.id === report.created_by_id">
                          <font-awesome-icon icon="trash" class="force-danger-all"/>
                          Delete
                        </button>
                      </template>
                    </div>
                  </div>
                </td>
              </tr>
            </template>
          </template>
          </tbody>
        </table>
      </div>
    </div>
    <new-psc-inspection-report/>
    <import-psc-report-modal />
  </div>

  <!--  TODO: create NewPscInspection modal  -->
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {vueAppMixin} from "@/mixins/vueAppMixin";
import {PaginationMixin} from "@/mixins/PaginationMixin";
import AppLoading from "@/components/elements/AppLoading";
import NewPscInspectionReport from "@/components/layouts/NewPscInspectionReport";
import {AlertService} from "../../../services/AlertService";
import {permissionMixin} from "@/mixins/permissionMixins";
import {ReportService} from "@/services/ReportService";
import _ from 'lodash';
import ImportPscReportModal from "@/components/layouts/ImportPscReportModal.vue";
import attachmentMixin from "@/mixins/attachmentMixin";
import DeficiencyStatusIndicator from "@/components/modules/psc/DeficiencyStatusIndicator.vue";
import 'vue2-datepicker/index.css';
import en from "vue2-datepicker/locale/es/en";
import TableColumnSearch from "@/components/common/TableColumnSearch.vue";

export default {
  name: "PscIndex",
  data() {
    return {
      filters: {
        page: 1,
        count: 30,
        fleet_id: null,
        status_id: null,
        office_id: null,
        port_id: null,
        country_id: null,
        flag_id: null,
        company_id: null,
        search:'',
        date_from : null,
        date_to   : null,
        category:'inspection_date_original_format',
        order_position:'desc',
        is_using_psc_list_view:true,
        vessel: null,
        manager: null,
        title: null,
        report_status: null,
        port: null,
        country: null,
        inspection_date: null,
        deficiencyCount: null,
        detention: null,
        responsible_person: null,
        person_in_charge: null,
        created_by: null,
      },
      date_range : null,
      ports:[],
      exportVesselId: null,
      exportDeficiencyCount: null,
      toExport: false,
      loading: false,
    }
  },
  components: {
    TableColumnSearch,
    DeficiencyStatusIndicator,
    'new-psc-inspection-report': NewPscInspectionReport,
    'import-psc-report-modal': ImportPscReportModal,
    'loading': AppLoading,
    DatePicker: () => import('vue2-datepicker')
  },
  // mixins: [PaginationMixin],
  mixins: [vueAppMixin, PaginationMixin, permissionMixin,attachmentMixin],
  methods: {
    ...mapActions([
      'addRequestKeys',
      'generateRequestKeys',
      'getPscReports',
      'deletePsc',
      'downloadPscList',
      'downloadPscStatusHistory',
    ]),

    getLatestAttachment(attachments) {
      if (!Array.isArray(attachments)) {
        return null;
      }

      const active = attachments.filter(a => !a.deleted_at);
      if (active.length === 0) {
        return null;
      }

      return active.reduce((latest, current) => {
        const latestTime = latest.created_at ? new Date(latest.created_at).getTime() : 0;
        const currentTime = current.created_at ? new Date(current.created_at).getTime() : 0;

        if (currentTime !== latestTime) {
          return currentTime > latestTime ? current : latest;
        }
        return current.id > latest.id ? current : latest;
      });
    },
    getDownloadParam(fileType) {
      const selectedCountry = this.countryKeys.filter((country) => {
        return country.id === this.filters.country_id;
      });

      const selectedPort = this.ports.filter((port) => {
        return port.id === this.filters.port_id;
      });

      const selectedFleet = this.fleetKeys.filter(fleet => {
        return fleet.id === this.filters.fleet_id
      })

      const params = {
        file_type  : fileType,
        // country    : selectedCountry.length === 0 ? 'ALL COUNTRIES' : selectedCountry[0].name,
        // port       : selectedPort.length === 0 ? 'ALL PORTS'        : selectedPort[0].name,
        // fleet      : selectedFleet.length === 0 ? 'ALL FLEET'       : selectedFleet[0].name,
        order_position : this.filters.order_position,
        search : this.filters.search,
        is_using_psc_list_view : true,
        category : this.filters.category
      }

      if (this.filters.country_id !== null) {
        params.country_id = this.filters.country_id;
      }

      if (this.filters.port_id !== null) {
        params.port_id = this.filters.port_id;
      }

      if (this.filters.fleet_id !== null) {
        params.fleet_id = this.filters.fleet_id;
      }

      if (this.filters.date_from !== null) {
        params.date_from = this.filters.date_from;
      }

      if (this.filters.date_to !== null) {
        params.date_to = this.filters.date_to;
      }

      if(params?.is_using_psc_list_view === true){

        if (this.filters.vessel !== null) {
          params.vessel = this.filters.vessel;
        }

        if (this.filters.manager !== null) {
          params.manager = this.filters.manager;
        }

        if (this.filters.title !== null) {
          params.title = this.filters.title;
        }

        if (this.filters.report_status !== null) {
          params.report_status = this.filters.report_status;
        }

        if (this.filters.port !== null) {
          params.port = this.filters.port;
        }

        if (this.filters.country !== null) {
          params.country = this.filters.country;
        }

        if (this.filters.inspection_date) {
          params.inspection_date = this.filters.inspection_date
        }

        if (this.filters.deficiencyCount !== null) {
          params.deficiencyCount = this.filters.deficiencyCount;
        }

        if (this.filters.detention !== null) {
          params.detention = this.filters.detention;
        }

        if (this.filters.responsible_person !== null) {
          params.responsible_person = this.filters.responsible_person;
        }

        if (this.filters.person_in_charge !== null) {
          params.person_in_charge = this.filters.person_in_charge;
        }

        if (this.filters.created_by !== null) {
          params.created_by = this.filters.created_by;
        }
      }

      return params;
    },
    async setVesselsToTable(){
      this.loading = true
      this.filters.page = 1
      await this.getPscReports(this.filters)
      this.loading = false
    },
    async downloadReportStatusHistory() {
      const params = this.getDownloadParam('excel');
      swal.fire({
        'title': `GENERATING PSC REPORTS STATUS HISTORY <br>Please wait.....`,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false
      })
      swal.showLoading()
      let response = await this.downloadPscStatusHistory(params);
      swal.close();

      if (response === false) {
        return AlertService.errorAlert('Theres an error downloading the file. Please try again later!', 'DOWNLOADING FILE');
      }
      let mime_type = 'application/vnd.ms-excel';
      let url = window.URL.createObjectURL(new Blob([response],{type:mime_type}))

      let filename=`PSC_STATUS_HISTORY_REPORT` +
        // params.country.replace(/\s/g, '_').toUpperCase() +
        // `_` + params.port.replace(/\s/g, '_').toUpperCase() +
        // `_` + params.fleet.replace(/\s/g, '_').toUpperCase() +
        `.xlsx`;

      const link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
    },
    async downloadReport(fileType){
      const params = this.getDownloadParam(fileType);
      swal.fire({
        'title': `GENERATING PSC INSPECTION LIST ${fileType === 'pdf' ? 'PDF' : 'EXCEL'} REPORT <br>Please wait.....`,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false
      })
      swal.showLoading()
      let response = await this.downloadPscList(params);
      swal.close();
      if (response === false) {
        return AlertService.errorAlert('Theres an error downloading the ' + fileType.toUpperCase() + ' file. Please try again later!', 'DOWNLOADING FILE');
      }
      let mime_type = fileType === 'pdf' ? 'application/pdf' : 'application/vnd.ms-excel'
      let url = window.URL.createObjectURL(new Blob([response],{type:mime_type}))

      fileType = (fileType !== 'pdf') ? 'xlsx' : 'pdf';

      let filename=`PSC_INSPECTION_LIST_REPORT` +
        // params.country.replace(/\s/g, '_').toUpperCase() +
        // `_` + params.port.replace(/\s/g, '_').toUpperCase() +
        // `_` + params.fleet.replace(/\s/g, '_').toUpperCase() +
        `.${fileType}`;

      const link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
    },
    getPortsByCountry(id) {
      this.ports = id ? this.portKeys.filter(port => port.country_id === id) : [];
      this.filters.port_id=null;
    },
    async exportBlankTemplate(resetToDefault = false) {
      if (resetToDefault === true) {
        this.toExport = false;
        this.exportVesselId = null;
        this.exportDeficiencyCount = null;
        return;
      }

      let vesselId = this.exportVesselId;
      let deficiencyCount = this.exportDeficiencyCount;
      const deficiencyCountIsNaN = isNaN(deficiencyCount);
      const vessel = this.vesselKeys.filter(vessel => vessel.id === vesselId)[0];

      let errorMsg = "";

      if (!vessel && !deficiencyCount) {
        errorMsg = "Number of Deficiency and Vessel is required";
      } else if (!vessel) {
        errorMsg = "Please select a vessel";
      } else if (deficiencyCountIsNaN || deficiencyCount < 1 || deficiencyCount > 30 || !deficiencyCount) {
        if (deficiencyCountIsNaN) {
          errorMsg = "Number of Deficiency must be a number";
        } else if (deficiencyCount > 30) {
          errorMsg = "Number of Deficiency must be a positive number with range from 1 to 30";
        }
      }

      if (errorMsg != "") {
        AlertService.errorAlert(errorMsg, 'PSC Inspection Export');
        // await this.exportBlankTemplate(true);
        return;
      }

      swal.fire({title: 'Downloading Template... Please wait...'});
      swal.showLoading();

      deficiencyCount = parseInt(isNaN(deficiencyCount) || !deficiencyCount ? 0 : deficiencyCount);
      const vesselName = (vessel.name).toUpperCase();
      const report = 'Psc Inspection';
      const name = [report, 'Report', vesselName, 'TEMPLATE'].join(' ');

      let path = name.replaceAll(' ', '_') + '.xlsx';
      let mime_type = 'application/vnd.ms-excel';
      const response = await ReportService.downloadPscReportTemplate(vessel.id, this.exportDeficiencyCount);

      let url = window.URL.createObjectURL(new Blob([response.data], {type: mime_type}));
      const link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', path);

      swal.close();
      document.body.appendChild(link);
      link.click();

      AlertService.successAlert('Vessel "' + vesselName + '" ' + report + ' Template has downloaded successfully', report);
      await this.exportBlankTemplate(true);
    },
    async setPage(page = null) {
      this.loading = true;
      this.pagination.currentPage = page ?? 1;
      this.filters.page = page ?? 1
      await this.getPscReports(this.filters)
      this.loading = false;
    },
    showPscInspection(inspectionId) {
      this.$router.push(
        {
          name: 'PscMain',
          params: {
            id: inspectionId
          }
        }
      )
    },
    async showPscInspectionNewTab (inspectionId) {
      const route= this.$router.resolve(
        {
          name: 'PscMain',
          params: {
            id: inspectionId,
          },
        },
      )
      window.open(route.href,'_blank')
    },
    async verifyDelete(psc) {
      if (await AlertService.confirmDeleteAlert('DELETION OF PSC REPORT', 'Do you want to Delete this PSC Record?', 'Yes, Proceed!')) {
        swal.fire({
          title:'ENTER YOUR PASSWORD',
          input: 'password',
          inputAttributes: {
            autocapitalize: 'off'
          },
          confirmButtonText:'PROCEED DELETION',
          cancelButtonText: 'CANCEL',
          showCancelButton:true,
          allowOutsideClick:false,
          allowEscapeKey:false,
          allowEnterKey:false,
          confirmButtonColor:'#dc3545',
          showLoaderOnConfirm:true,
          preConfirm:async (inputValue)=> {
            const params = {type: 1, id: psc.id,password: inputValue}
            let response = await this.deletePsc(params);
            if (typeof response === 'boolean' && response) {
              return response;
            } else {
              if (response.hasOwnProperty('message') && !response.hasOwnProperty('errors')) {
                swal.showValidationMessage(response.message);
              }
              else{
                swal.showValidationMessage(response.errors.password.join(','));
              }
            }
          }
        })
          .then(async (result)=>{
            if(result.isConfirmed){
              this.successAlert('PSC RECORD DELETED SUCCESSFULLY','DELETE PSC REPORT');
              this.setPage(1)
            }
          });
      }
    },
    initializeWatcher(){
      this.$watch(()=>this.$route.query,async (present,previous)=>{
        this.filters.page=1
        this.filters.search=present?.search
        await this.getPscReports(this.filters)
      });
    },
    async handleFilterChange(key, value) {
      this.filters[key] = value

      // Reset page except for count change
      if (key !== 'count') {
        this.filters.page = 1
      }

      // Special handling
      if (key === 'country_id') {
        await this.$nextTick()
        this.getPortsByCountry(value)
      }

      this.loading = true

      try {
        await this.getPscReports(this.filters)
      } finally {
        this.loading = false
      }
    },

    async handleDateRange(dateRange) {
      this.date_range = dateRange

      this.filters.date_from = dateRange?.[0] || null
      this.filters.date_to = dateRange?.[1] || null
      this.filters.page = 1

      this.loading = true

      try {
        await this.getPscReports(this.filters)
      } finally {
        this.loading = false
      }
    },
    async sortByCategory(column){
      this.filters.category = column;
      this.filters.order_position = this.filters.order_position === 'desc' ? 'asc' : 'desc';
      this.handleFilterChange('category', column)
    }
  },
  async created() {
    this.loading = true;
    this.initializeWatcher()

    this.addRequestKeys([
      'getVesselKeys',
      'getFleetListKeys',
      'getReportStatusKeys',
      'getMngmtOfficeKeys',
      'getCountryListKeys',
      'getMngmtCompanyKeys',
      'getTimezoneKeys',
      'getEventOneKeys',
      'getEventImpactKeys',
      'getPortKeys',
    ]);

    // @NOTE: SAMPLE @params object
    // const params = {
    //   test_param: 'this is a test',
    //   __params: {
    //     getReportStatusKeys: {
    //       id: 4,
    //     }
    //   },
    // };

    const params = {};
    await this.generateRequestKeys(params);
    await this.getPscReports(this.filters);
    this.setPage2=_.debounce(this.setPage,250);

    this.loading = false;
  },
  computed: {
    en() {
      return en
    },
    ...mapGetters([
      'isLoading', 'reports', 'vesselKeys', 'fleetKeys', 'portKeys',
      'mngmntOfficeKeys', 'countryKeys', 'reportStatusKeys', 'mngmtCompanyKeys'
    ]),
    reportStatusKeyModify(){
      const renameMap = {
        new: 'NEW',
        open: 'OPEN'
      }

      return this.reportStatusKeys.map(v => ({
        ...v,
        name: renameMap[v.code] ?? v.name
      }))
    },
    dateRangeInspection: {
      get() {
        return this.filters.inspection_date || [null, null]
      },
      set(val) {
        this.filters.inspection_date = Array.isArray(val) && val.every(v => v === null) ? null : val
      }
    },
    finalizedReports() {
      let newReports = [];
      this.reports.forEach((report) => {
        let satisfiedCondition = (report.report_status_id !== 1) || (report.report_status_id === 1 && this.user.id === report.created_by_id)
        if (satisfiedCondition === true || this.isElite() === true) {
          newReports.push(report);
        }
      })

      return newReports;
    }
  },
  // watch:{
  //    async 'filters.count'(){
  //     this.loading = true;
  //     await this.getPscReports(this.filters)
  //     this.loading = false;
  //   },
  //   async 'filters.fleet_id'(){
  //     this.loading = true;
  //     await this.getPscReports(this.filters)
  //     this.loading = false;
  //   },
  //   async 'filters.country_id'(id) {
  //     this.$nextTick(() => {
  //       this.getPortsByCountry(id);
  //     })
  //     this.loading = true;
  //     await this.getPscReports(this.filters)
  //     this.loading = false;
  //   },
  //   async 'filters.port_id'() {
  //     this.loading = true;
  //     await this.getPscReports(this.filters)
  //     this.loading = false;
  //   },
  //   async 'date_range'() {
  //     this.loading = true;
  //     this.filters.date_from = this.date_range[0]
  //     this.filters.date_to = this.date_range[1]
  //     await this.getPscReports(this.filters)
  //     this.loading = false;
  //   },
  //   async 'filters.category'(category){
  //     this.loading = true;
  //     this.filters.category = category;
  //     this.filters.page = 1
  //     this.loading = true
  //     await this.getPscReports(this.filters)
  //     this.loading = false
  //   },
  //   async 'filters.order_position'(position){
  //     this.loading = true;
  //     this.filters.order_position = position;
  //     this.filters.page = 1
  //     this.loading = true
  //     await this.getPscReports(this.filters)
  //     this.loading = false
  //   }
  // }
}
</script>

<style scoped>
table tr td {
  font-size: 10px;
}

.force-align-top {
  display: inline-block;
  vertical-align: top;
}
/*#exportDeficiencyCount {
  max-width: 30%;
}*/

.custom-table-border thead tr th {
  border: 2px solid #d6d6d6 !important;
}
</style>
